<template>
    <div class="resume__quote-content">
      <h2 class="resume__quote-subtitle">Detalle de cotización</h2>
      <div class="radio__button-box">
        <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          content="content1"
          value="12"
          :interes="12"
          text="12 meses"
        />
        <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          content="content2"
          value="24"
          :interes="14"
          text="24 meses"
        />
        <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          content="content3"
          value="36"
          :interes="16"
          text="36 meses"
        />
        <!-- <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          content="content4"
          value="60"
          :interes="16"
          text="60 meses"
        /> -->
        
       
      </div>
      <!--  solo mostrar en desarrollos que cuenten con este plan (lomalta) -->
      <div class="radio__button-box" v-if="desarrollo == 'LomAlta'">
         <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          
          content="content5"
          value="-1"
          interes="0"
          text="Plan constructor"
        />
        <radio-button-quote
          :class="disabled"
          @onUpdatePlan="updateActivePlan"
          :activePlan="activePlan"
          content="content6"
          value="-2"
          interes="0"
          text="Plan construye tu casa"
        />
      </div>
      <!---->
      <div class="btn_box">
        <a
          href=""
          :class="disabled"
          @click.prevent="_getFinancial()"
          class="btn btn__resume"
          v-if="planconstructor == 0"
          >{{ loaderFinancial == true ? "cotizando..." : "cotizar" }}</a
        >
      </div>
      <div class="line_horizontal" :class="{ hider: planconstructor != 0 }"></div>
      <loader-resume v-if="loaderFinancial" />
      <div class="content__resume" v-if="resumeBox">
        <div :class="{ hider: planconstructor != 0 }">
          <h2 class="content__resume-subtitle">Resumen</h2>
          <p>
             Precio total del terreno:
            <span>${{ formatValue(selected.value) }}</span>
          </p>
          <!-- <p>
            Precio menos el 20% de enganche:
            <span>${{ formatValue(financial.financedAmount) }}</span>
          </p> -->
          <p>
            Monto del enganche (20% del valor del inmueble):
            <span>${{ formatValue(financial.advanceAmount) }}</span>
          </p>
          <p>
            Monto a financiar con interés:
            <span
              >${{
                formatValue(financial.interestAmount + financial.financedAmount)
              }}</span
            >
          </p>
          <!-- <p>
            Interés ({{ interes }}%):
            <span>${{ formatValue(financial.interestAmount) }}</span>
          </p> -->
          <p>
            Pago en parcialidades:
            <span>${{ formatValue(financial.partialAmount) }}</span>
          </p>
          <!--  <p class="consulta">
            <span>*Consulta nuestras promociones de 12 meses sin intereses</span>
          </p> -->
        </div>
      </div>
      <!--  solo mostrar en desarrollos que cuenten con este plan (lomalta) -->
      <div v-if="activePlan == -1 || activePlan == -2" style="text-align:center">
        <a @click.prevent="sendCotizacion()" href="" class="btn btn__send"
          >Enviar información</a
        >
        <div class="line_horizontal"></div>
      </div>
      <div v-if="activePlan == -1" class="content__resume-planconstructor">
        <img src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/planes-contructores/TM-Plan+Constructor.png" alt="">
      </div>
      <div v-if="activePlan == -2" class="content__resume-planconstructor">
        <img src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/planes-contructores/TM-Plan+Construye+tu+casa.png" alt="">
      </div>
     <!---->
      <div class="btn__box">
        <a
          :class="disabled"
          href=""
          @click.prevent="updateStepper"
          class="btn btn__back"
          >atras</a
        >
        <a
          v-if="resumeBox && planconstructor == 0"
          @click.prevent="_sendFinancial()"
          href=""
          class="btn btn__send"
          >enviar</a
        >
      </div>
    </div>
  </template>
  <script>
  import RadioButtonQuote from "../../quotelocation/RadioButtonQuote";
  import LoaderResume from "../../quotelocation/LoaderResume";
  import { mapActions, mapGetters } from "vuex";
  import Swal from "sweetalert2";
  
  export default {
    name: "ResumeQuote",
    data() {
      return {
        activePlan: "12",
        interes: "9",
        name: "",
        lastName: "",
        email: "",
        cp: "",
        planconstructor: 0,
        telephone: "",
        desarrollo: "",
        stepper: 2,
        spin: false,
        resumeBox: false,
        reset: 2,
        value: "I am the child.",
      };
    },
    props: ["user", "onResetQuote", "casasDeptos"],
    components: {
      RadioButtonQuote,
      LoaderResume,
    },
    computed: {
      ...mapGetters({
        selected: "getSelectedDpt",
        financial: "getSelectedStatusFinancial",
        loaderFinancial: "getStatusLoadingFinancial",
      }),
      disabled() {
        if (this.loaderFinancial) {
          return "btn__disabled";
        } else {
          return "";
        }
      },
    },
    methods: {
      ...mapActions(["getFinancial", "sendFinancial", "sendDataSheet"]),
      async _getFinancial() {
        this.resumeBox = false;
        try {
          let financialData = {
            locationId: this.selected.id,
            months: this.activePlan,
          };
          await this.getFinancial(financialData);
        } catch (e) {
          Swal.fire({
              icon: "error",
              title: "Ha ocurrido un error, intente mas tarde",
              confirmButtonColor: "#822013",
              allowOutsideClick: false,
              confirmButtonText: "OK",
              showClass: {
                  popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                  popup: 'animate__animated animate__fadeOutUp'
              }
          }).then(() => {
              this.onResetQuote()
          })
        } finally {
          this.resumeBox = true;
        }
      },
      async _sendDataSheetDocument(sheet) {
        let type = ''
        if(sheet){
          if(this.activePlan==-1){
            type="Plan constructor"
          }else if(this.activePlan==-2){
            type="Plan construye tu casa"
          }
        }
        let body = {
          "Nombre": this.name,
          "Apellido": this.lastName,
          "Correo": this.email,
          "Telefono": this.telephone,
          "Ciudad_Codigo_Postal": this.cp,
          "Desarrollo": this.desarrollo,
          "Ubicacion": this.selected.name,
          "Valor": this.selected.value,
          "Enganche": sheet ? type : this.financial.advanceAmount,
          "Meses_a_pagar": sheet ? type : this.activePlan,
          "Monto_a_pagar_mensualmente": sheet ? type : this.financial.partialAmount,
        };
        try {
          await this.sendDataSheet(body);
        } catch (e) {
          Swal.fire({
              icon: "error",
              title: "Ha ocurrido un error, intente mas tarde",
              confirmButtonColor: "#822013",
              allowOutsideClick: false,
              confirmButtonText: "OK",
              showClass: {
                  popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                  popup: 'animate__animated animate__fadeOutUp'
              }
          }).then(() => {
              this.onResetQuote()
          })
        }
      },
      async _sendFinancial() {
        try {
          Swal.fire({
            icon: "success",
            title: "Mensaje enviado correctamante",
            text: "La cotizacion te la enviaremos en breve al correo electronico que proporcionaste en el paso anterior.",
            confirmButtonColor: "#14274a",
            allowOutsideClick: false,
            confirmButtonText: "OK",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            this.onResetQuote();
          });
          await this.sendFinancial({
            locationId: this.selected.id,
            email: this.email,
            customerName: `${this.name} ${this.lastName}`,
            months: this.activePlan,
            city: this.cp,
            phone: this.telephone
          });
          this._sendDataSheetDocument();
          this.$emit("onUpdateStepper", (this.stepper -= 1));
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Ha ocurrido un error, intente mas tarde",
            confirmButtonColor: "#822013",
            allowOutsideClick: false,
            confirmButtonText: "OK",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            this.onResetQuote();
          });
        }
      },
      formatValue(value) {
        let val = (value / 1).toFixed(2).replace(",", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      updateActivePlan(plan, interes) {
        this.activePlan = plan;
        this.interes = interes;
        this.planC();
      },
      planC() {
        if (this.activePlan == -1) {
          this.planconstructor = 1;
        } else if (this.activePlan == -2) {
          this.planconstructor = 2;
        } else {
          this.planconstructor = 0;
          this._getFinancial();
        }
      },
      updateStepper() {
        this.$emit("onUpdateStepper", (this.stepper -= 1));
      },
      userElements(element) {
        this.name = element.name;
        this.lastName = element.lastName;
        this.email = element.email;
        this.cp = element.cp;
        this.telephone = element.telephone;
        this.desarrollo = element.desarrollo;
      },
      async sendCotizacion() {
              try {
                  Swal.fire({
                      icon: "success",
                      title: "Mensaje enviado correctamante",
                      text: "la cotizacion te la enviaremos al correo electronico que proporcionaste en el paso anterior.",
                      confirmButtonColor: "#14274a",
                      allowOutsideClick: false,
                      confirmButtonText: "OK",
                      showClass: {
                          popup: 'animate__animated animate__fadeInDown'
                      },
                      hideClass: {
                          popup: 'animate__animated animate__fadeOutUp'
                      }
                  }).then(() => {
                      this.onResetQuote()
                  }); 
                  await this.sendFinancial({
                      locationId: this.selected.id,
                      email: this.email,
                      customerName: `${this.name} ${this.lastName}`,
                      months: this.activePlan,
                      city: this.cp,
                      phone: this.telephone
                  });
                  this._sendDataSheetDocument(true);
              } catch (e) {
                  Swal.fire({
                      icon: "error",
                      title: "Ha ocurrido un error, intente mas tarde",
                      confirmButtonColor: "#822013",
                      allowOutsideClick: false,
                      confirmButtonText: "OK",
                      showClass: {
                          popup: 'animate__animated animate__fadeInDown'
                      },
                      hideClass: {
                          popup: 'animate__animated animate__fadeOutUp'
                      }
                  }).then(() => {
                      this.onResetQuote()
                  })
              }
          },
    },
    mounted() {
      this.user.forEach(this.userElements);
      
    },
  };
  </script>
  <style scoped>
  .hider {
    display: none !important;
  }
  </style>